<template>
  <div>
    <div class="top">费用详情</div>
    <div class="contaa jh-page">
      <div class="top1 jh-card">
        <div class="title">{{ name }}</div>
        <div class="time">{{ classa }}</div>
      </div>
      <div class="top2 jh-card" v-if="dataimfo.length > 0">
        <div class="toptitleone">
          <div class="titleone">{{ title }}</div>
          <div class="timeone">缴费截止：{{ creattime }}</div>
        </div>
        <div class="kximfo">
          <van-checkbox-group
            v-model="checked"
            @change="checkone"
            ref="checkboxGroup"
          >
            <div
              v-for="(item, index) in dataimfo"
              :key="item.itemid"
              class="fee-item"
            >
              <van-checkbox
                v-if="item.isRequired"
                :name="item"
                disabled
                checked-color="#dd0000"
                :ref="(el) => setCheckboxRef(el, index)"
              >
                <span class="oneprice"
                  >￥{{ (item.price / 100).toFixed(2) }}</span
                >
                <span class="onecheck">必选</span>
                <span class="onename">{{ item.itemName }}</span>
              </van-checkbox>
              <van-checkbox
                v-else
                :name="item"
                checked-color="#dd0000"
                :ref="(el) => setCheckboxRef(el, index)"
                @click.stop
              >
                <span class="oneprice"
                  >￥{{ (item.price / 100).toFixed(2) }}</span
                >
                <span class="onename">{{ item.itemName }}</span>
              </van-checkbox>
            </div>
          </van-checkbox-group>
          <div class="select-all">
            <van-checkbox
              v-model="allchecked"
              @click="checkAll"
              checked-color="#dd0000"
              ><span class="dataname">全选</span></van-checkbox
            >
          </div>
        </div>

        <div class="heji">
          <span class="heji-label">合计</span>
          <span class="hejiprice">￥{{ (allfee / 100).toFixed(2) }}</span>
        </div>
      </div>
      <div v-else class="empty-wrap jh-card">
        <van-empty description="暂无待缴费" />
      </div>
      <div class="top3 jh-card" v-if="dataimfo.length > 0">
        <div class="toptitle">缴费说明</div>
        <div class="note-body">
          <span class="zistyle">{{ note }}</span>
        </div>
      </div>
    </div>
    <div class="surebtn" v-if="dataimfo.length > 0">
      <van-button
        type="danger"
        color="#dd0000"
        round
        block
        @click="paymoney"
        v-if="allfee > 0"
        >确认缴费</van-button
      >
      <van-button type="danger" color="#dd0000" round block v-else disabled
        >确认缴费</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      dataimfo: [],
      bxdata: [],
      allfee: 0,
      bxprice: 0,
      kxprice: 0,
      datafee: [],
      creattime: "",
      title: "",
      note: "",
      checked: [],
      allchecked: false,
      name: "",
      classa: "",
      checkboxRefs: [],
    };
  },

  mounted() {
    this.getimfo();
  },

  methods: {
    setCheckboxRef(el, index) {
      if (el) this.checkboxRefs[index] = el;
    },
    //全选，反选
    checkAll() {
      if (this.allchecked) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll();
        this.checked = this.bxdata;
      }
    },
    //选择某一个
    checkone() {
      this.allfee = 0;
      if (this.checked.length == this.dataimfo.length) {
        this.allchecked = true;
      } else {
        this.allchecked = false;
      }
      if (this.checked.length > 0) {
        this.checked.forEach((item) => {
          this.allfee += item.price;
        });
      }
    },
    getimfo() {
      this.name = sessionStorage.getItem("name");
      let id = this.$route.query.id;
      let studentid = this.$route.query.studentid;
      this.fetchget(`/api/Order/mypaymentdetail`, {
        id: id,
        studentid: studentid,
      }).then((res) => {
        if (res.code > 0) {
          this.dataimfo = res.data.items;
          this.creattime = res.data.endDate.split("T")[0];
          this.title = res.data.title;
          this.note = res.data.note || "无";
          this.classa =
            (res.data.orgInfo &&
              res.data.orgInfo.extraProperties &&
              res.data.orgInfo.extraProperties.NamePath) ||
            sessionStorage.getItem("class") ||
            "";
          this.bxdata = [];
          this.allfee = 0;
          res.data.items.forEach((item) => {
            if (item.isRequired) {
              this.bxdata.push(item);
              this.allfee += item.price;
            }
          });
          this.checked = this.bxdata.slice();
        } else {
          this.$notify({
            type: "danger",
            message: res.msg,
            color: "#ad0000",
            background: "#ffe1e1",
          });
        }
      });
    },
    paymoney() {
      let brr = [];
      this.checked.forEach((item) => {
        brr.push(item.itemid);
      });
      let data = {
        payMethod: "wx",
        payItems: brr,
        totalFee: this.allfee,
        paymentId: this.$route.query.id,
        studentid: this.$route.query.studentid,
      };
      if (this.allfee > 0) {
        Toast.loading({
          message: "订单创建中……...",
          forbidClick: true,
        });

        this.fetchpost("/api/Order/create", data).then((res) => {
          if (res.code < 0) {
            this.$notify({
              type: "danger",
              message: res.msg,
              color: "#ad0000",
              background: "#ffe1e1",
            });
          } else {
            Toast.loading({
              message: "已经创建，跳转中...",
              forbidClick: true,
            });
            brr = [];

            let path = "pages/index/index?id=" + res.data;
            window.AppBridgeGlobal.gotoWXMiniProgram(
              {
                username: "gh_d08e9c6e1014",
                path: path,
                type: "0",
              },
              function (jumpRes) {
                if (jumpRes.tmCode === 200) {
                  Toast.loading({
                    duration: 3000,
                    message: "正在跳转...",
                    forbidClick: true,
                  });
                } else {
                  this.$notify({
                    type: "danger",
                    message: jumpRes.tmMsg,
                  });
                }
              }
            );

            window.location.href = res.msg;
          }
        });
      } else {
        this.$notify({
          type: "danger",
          message: "家长可不必缴费,等下次抵扣",
          color: "#ad0000",
          background: "#ffe1e1",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$brand: #dd0000;
$bg: #f3f5f9;
$text: #0f172a;
$muted: #64748b;
$border: #e2e8f0;
$radius: 10px;
$shadow: 0 4px 16px rgba(15, 23, 42, 0.06);

.jh-page {
  background: $bg;
}

.jh-card {
  background: #fff;
  border-radius: $radius;
  border: 1px solid $border;
  box-shadow: $shadow;
}

.contaa {
  overflow-y: auto;
  min-height: 200px;
  margin-bottom: 90px;
  padding: 14px;
  background: $bg;
  box-sizing: border-box;
}

.top {
  width: 100%;
  height: 44px;
  background-color: $brand;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 44px;
  letter-spacing: 1px;
  color: #ffffff;
}

.top1 {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 12px;
  padding: 16px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  color: $text;
}

.time {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.4;
  color: $muted;
}

.top2 {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 12px;
  padding: 0;
  overflow: hidden;
}

.toptitleone {
  padding: 14px 16px 10px;
  border-bottom: 1px solid $border;
}

.titleone {
  font-size: 16px;
  font-weight: 600;
  color: $text;
  line-height: 1.4;
  width: 100%;
  white-space: normal;
}

.timeone {
  margin-top: 6px;
  font-size: 12px;
  color: $muted;
  line-height: 1.4;
}

.kximfo {
  padding: 6px 16px 4px;
}

.fee-item {
  padding: 4px 0;
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
  }
}

.onecheck {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;
  font-size: 11px;
  color: $brand;
  background: #fff1f1;
  border-radius: 4px;
  vertical-align: middle;
}

.oneprice {
  color: $brand;
  font-weight: 700;
  font-size: 15px;
}

.onename {
  margin-left: 8px;
  font-size: 14px;
  color: $text;
}

.select-all {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px dashed $border;
}

.dataname {
  font-size: 14px;
  color: #475569;
  font-weight: 500;
}

.heji {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  min-height: 56px;
  padding: 12px 16px;
  background: #fffafa;
  border-top: 1px solid $border;
  line-height: 1.2;
}

.heji-label {
  font-size: 14px;
  color: #475569;
  font-weight: 500;
}

.hejiprice {
  font-size: 24px;
  font-weight: 700;
  color: $brand;
  letter-spacing: 1px;
}

.top3 {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 12px;
  padding: 14px 16px 16px;
}

.toptitle {
  font-size: 15px;
  font-weight: 600;
  color: $text;
  line-height: 1.4;
  margin-bottom: 8px;
}

.note-body {
  padding: 10px;
  background: #f8fafc;
  border-radius: 6px;
}

.zistyle {
  color: #475569;
  font-weight: normal;
  font-size: 13px;
  line-height: 1.7;
  word-break: break-word;
}

.empty-wrap {
  padding: 24px 0;
  margin-bottom: 12px;
}

.surebtn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid $border;
  box-shadow: 0 -4px 12px rgba(15, 23, 42, 0.04);
}
</style>
